import React from "react";
import { IconButton, makeStyles, Tooltip } from "@material-ui/core";
import Delete from "@material-ui/icons/DeleteForever";

export default function DeleteIconButton(props) {
	const { tooltipTitle, onClick } = props;
	const classes = useStyles();
	return (
		<IconButton className={`${classes.delete} ${classes.iconButton}`} onClick={onClick}>
			<Tooltip title={tooltipTitle} aria-label="delete">
				<Delete />
			</Tooltip>
		</IconButton>
	);
}

const useStyles = makeStyles((theme) => ({
	delete: {
		"&:hover": {
			"& svg": {
				fill: "#FF1531",
			},
		},
	},
	iconButton: {
		"& svg": {
			fill: theme.palette.primary.main,
		},
	},
}));
